<rect width="32" height="32" rx="16" fill="currentColor" />
<g clip-path="url(#clip0_6282_305)">
    <path
        d="M16.5153 5.99969C11.0064 5.99969 8.06104 9.51223 8.06104 13.349C8.06104 15.1323 9.04283 17.3479 10.6791 18.0504C11.1155 18.2665 11.0609 17.9964 11.4427 16.5373C11.4973 16.4292 11.4427 16.3211 11.3336 16.2131C9.04282 13.5652 10.8973 8.21529 16.188 8.21529C23.8241 8.21529 22.406 18.6989 17.4971 18.6989C16.2426 18.6989 15.3153 17.7262 15.588 16.4833C15.9698 15.0242 16.6789 13.5111 16.6789 12.4303C16.6789 9.78242 12.7518 10.2147 12.7518 13.6732C12.7518 14.754 13.1336 15.4565 13.1336 15.4565C13.1336 15.4565 11.8791 20.5362 11.6064 21.4549C11.2246 23.076 11.6609 25.6699 11.7154 25.8861C11.7154 25.9941 11.8791 26.0482 11.9336 25.9401C12.0427 25.778 13.5699 23.6164 14.0063 22.0493C14.1699 21.4549 14.8244 19.1852 14.8244 19.1852C15.2608 19.9418 16.4607 20.5902 17.7698 20.5902C21.6424 20.5902 24.4241 17.2398 24.4241 13.0788C24.3696 8.97184 20.9333 5.99969 16.5153 5.99969Z"
        fill="var(--gw-rd-white-color)"
    />
</g>
<defs>
    <clipPath id="clip0_6282_305">
        <rect
            width="16.3631"
            height="19.9993"
            fill="var(--gw-rd-white-color)"
            transform="translate(8.06104 6)"
        />
    </clipPath>
</defs>
